import React from 'react';
import Select from '../Select/Select';
import { DOCUMENT_TYPES_OPTIONS } from '../../constants';

const SelectDocumentType = ({ ...props }) => {
  return <Select options={DOCUMENT_TYPES_OPTIONS} label={'Тип документа'} placeholder={'Выберите из списка'} {...props} />;
};

export default SelectDocumentType;
